import { useField } from 'formik';

import { controlError } from 'utils';

import { Input, InputProps } from '../input';

export interface InputFieldProps extends Omit<InputProps, 'name'> {
  name: string;
  label?: string;
  displayValue?: unknown;
  controlErrorLabel?: boolean;
  onChange?: InputProps['onChange'];
  mapValue?: (value: unknown) => unknown;
}

export function InputField({
  name,
  label,
  onChange,
  mapValue,
  displayValue,
  controlErrorLabel = true,
  ...props
}: InputFieldProps) {
  const [field, meta, helpers] = useField<unknown>(name);

  const errorText = controlError(meta, name, label, controlErrorLabel);

  return (
    <Input
      {...props}
      {...field}
      label={label}
      error={!!errorText}
      helperText={errorText}
      value={displayValue ?? field.value ?? ''}
      onChange={(event) => {
        if (mapValue) {
          helpers.setValue(mapValue(event.target.value), true);
        } else {
          field.onChange(event);
        }
        onChange?.(event);
      }}
    />
  );
}
